module.exports = __webpack_public_path__ + "img/alert-info.6adf63ec.svg";